import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs';
import { getMetaValue } from "../plugins/src/metadata"

export default class extends Controller {
  static targets = ["item"]
  static values = {
    url: String,
    handle: String
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: this.handleValue || ".drag-handle",
      animation: 150,
      onEnd: this.onEnd.bind(this)
    });
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  }

  onEnd(event) {
    const slidesEmbedId = event.item.dataset.id;
    const newPosition = event.newIndex;

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": getMetaValue("csrf-token"),
      },
      body: JSON.stringify({
        slides_embed_id: slidesEmbedId,
        position: newPosition
      })
    })
    .then(response => {
      if (!response.ok) {
        console.error('Failed to update position');
      }
    })
    .catch(error => console.error('Error:', error));
  }
}
